import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import app from "../../../../global-account/app.js";
import { Button, toast, useAuthentication, useModalStore, useQueryB3 } from "../../../../global-account/react/index.js";
import { client } from "../../../../shared/utils/thirdweb.js";
import { Copy, Loader2, Pencil } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useProfiles, useUnlinkProfile } from "thirdweb/react";
import { getProfileDisplayInfo } from "../../utils/profileDisplay.js";
import ModalHeader from "../ModalHeader/ModalHeader.js";
import LinkedAccountItem from "./LinkedAccountItem.js";
export const LinkAccount = ({
  partnerId,
  onLogout: _onLogout,
  chain
}) => {
  const [unlinkingAccountId, setUnlinkingAccountId] = useState(null);
  const [profileToUnlink, setProfileToUnlink] = useState(null);
  const {
    data: profilesRaw = [],
    isLoading: isLoadingProfiles
  } = useProfiles({
    client
  });
  const {
    mutate: unlinkProfile,
    isPending: isUnlinking
  } = useUnlinkProfile();
  const setB3ModalContentType = useModalStore(state => state.setB3ModalContentType);
  const isLinking = useModalStore(state_0 => state_0.isLinking);
  const setB3ModalOpen = useModalStore(state_1 => state_1.setB3ModalOpen);
  const contentType = useModalStore(state_2 => state_2.contentType);
  const {
    user,
    setUser
  } = useAuthentication(partnerId);
  const [isUpdatingCode, setIsUpdatingCode] = useState(false);
  const [newReferralCode, setNewReferralCode] = useState("");
  const [isEditingCode, setIsEditingCode] = useState(false);
  const referallCodeRef = useRef(null);
  const {
    data: referrals,
    isLoading: isLoadingReferrals
  } = useQueryB3("referrals", "find", {
    query: {
      referrerId: user?.userId
    }
  }, !!user?.userId);
  const showReferralInfo = contentType?.showReferralInfo ?? false;
  const mutationOptions = {
    onError: error => {
      console.error("Error Unlinking account:", error);
      toast.error(error.message);
    },
    onSuccess: async data => {
      console.log("Raw Link Account Data:", data);
      try {
        console.log("Sync user data...");
        await app.service("users").syncTwProfiles({});
      } catch (refreshError) {
        console.warn("⚠️ Could not sync user data:", refreshError);
      }
    }
  };
  // Fetch referred users
  const currentReferralCode = user?.referralCode || user?.userId || "";
  const handleCopyCode = async () => {
    try {
      await navigator.clipboard.writeText(currentReferralCode);
      toast.success("Referral code copied to clipboard!");
    } catch (error_0) {
      toast.error("Failed to copy referral code");
    }
  };
  const handleUpdateReferralCode = async () => {
    if (!newReferralCode) return;
    setIsUpdatingCode(true);
    try {
      // @ts-expect-error - setReferralCode is not typed for some reason
      const newUser = await app.service("users").setReferralCode({
        userId: user?.userId,
        referralCode: newReferralCode
      });
      setUser(newUser);
      toast.success("Referral code updated successfully!");
      setIsEditingCode(false);
      setNewReferralCode("");
    } catch (error_1) {
      toast.error("Failed to update referral code");
    } finally {
      setIsUpdatingCode(false);
    }
  };
  const profiles = profilesRaw.filter(profile => !["custom_auth_endpoint"].includes(profile.type)).map(profile_0 => ({
    ...getProfileDisplayInfo(profile_0),
    originalProfile: profile_0
  }));
  console.log("profiles :", profiles);
  // Reset confirmation state after 3 seconds
  useEffect(() => {
    if (profileToUnlink) {
      const timer = setTimeout(() => {
        setProfileToUnlink(null);
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [profileToUnlink]);
  const handleUnlinkClick = profile_1 => {
    // If this profile is already pending confirmation, perform the unlink
    if (profileToUnlink?.title === profile_1.title) {
      setUnlinkingAccountId(profile_1.title);
      try {
        unlinkProfile({
          client,
          profileToUnlink: profile_1.originalProfile
        }, mutationOptions);
      } catch (error_2) {
        console.error("Error unlinking account:", error_2);
      } finally {
        setUnlinkingAccountId(null);
        setProfileToUnlink(null);
      }
    } else {
      // First click - set pending confirmation
      setProfileToUnlink(profile_1);
    }
  };
  const handleOpenLinkModal = () => {
    setB3ModalOpen(true);
    setB3ModalContentType({
      type: "linkNewAccount",
      partnerId,
      chain,
      onSuccess: async () => {
        // Let the LinkAccount component handle modal closing
      },
      onError: () => {
        // Let the LinkAccount component handle errors
      },
      onClose: () => {
        // Let the LinkAccount component handle closing
      }
    });
  };
  return _jsxs("div", {
    className: "linked-accounts-settings",
    children: [_jsx(ModalHeader, {
      title: "Linked Accounts"
    }), _jsxs("div", {
      className: "linked-accounts-section space-y-4 p-5",
      children: [isLoadingProfiles ? _jsx("div", {
        className: "linked-accounts-loading flex justify-center py-8",
        children: _jsx(Loader2, {
          className: "text-b3-grey animate-spin"
        })
      }) : profiles.length > 0 ? _jsx("div", {
        className: "linked-accounts-list space-y-4",
        children: profiles.map(profile_2 => _jsx(LinkedAccountItem, {
          profile: profile_2,
          profileToUnlink: profileToUnlink,
          unlinkingAccountId: unlinkingAccountId,
          isUnlinking: isUnlinking,
          onUnlinkClick: handleUnlinkClick
        }, profile_2.title))
      }) : _jsx("div", {
        className: "linked-accounts-empty font-neue-montreal-medium text-b3-foreground-muted py-8 text-center",
        children: "No linked accounts found"
      }), _jsx(Button, {
        onClick: handleOpenLinkModal,
        disabled: isLinking,
        className: "b3-modal-link-new-account-button bg-b3-primary-blue hover:bg-b3-primary-blue/90 border-white/12 group relative h-12 w-full rounded-xl border-2 px-[18px] text-base font-semibold text-white shadow-[inset_0px_0px_0px_1px_rgba(10,13,18,0.18),inset_0px_-2px_0px_0px_rgba(10,13,18,0.05)] transition-all",
        children: _jsxs("div", {
          className: "flex items-center justify-center gap-1.5",
          children: [_jsx("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "shrink-0",
            children: _jsx("path", {
              d: "M10.0001 13.3333V6.66667M6.66675 10H13.3334M18.3334 10C18.3334 14.6024 14.6025 18.3333 10.0001 18.3333C5.39771 18.3333 1.66675 14.6024 1.66675 10C1.66675 5.39763 5.39771 1.66667 10.0001 1.66667C14.6025 1.66667 18.3334 5.39763 18.3334 10Z",
              stroke: "currentColor",
              strokeWidth: "1.67",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          }), _jsx("span", {
            children: "Link new account"
          })]
        })
      })]
    }), showReferralInfo && (/* Referral Section */
    _jsxs("div", {
      className: "referrals-section space-y-4",
      children: [_jsx("h3", {
        className: "referrals-title text-b3-grey font-neue-montreal-semibold text-xl",
        children: "Referrals"
      }), _jsxs("div", {
        className: "referral-code-container bg-b3-line rounded-xl p-4",
        children: [isEditingCode && _jsxs("div", {
          className: "referral-code-header-editing",
          children: [_jsx("div", {
            className: "referral-code-title text-b3-grey font-neue-montreal-semibold",
            children: "Your Referral Code"
          }), _jsx("div", {
            className: "referral-code-description text-b3-foreground-muted font-neue-montreal-medium text-sm",
            children: "Share this code with friends to earn rewards"
          })]
        }), _jsxs("div", {
          className: "referral-code-content flex items-center justify-between",
          children: [!isEditingCode && _jsxs("div", {
            className: "referral-code-header",
            children: [_jsx("div", {
              className: "referral-code-title text-b3-grey font-neue-montreal-semibold",
              children: "Your Referral Code"
            }), _jsx("div", {
              className: "referral-code-description text-b3-foreground-muted font-neue-montreal-medium text-sm",
              children: "Share this code with friends to earn rewards"
            })]
          }), _jsx("div", {
            className: "referral-code-actions flex items-center gap-2",
            children: isEditingCode ? _jsxs("div", {
              className: "referral-code-edit-form flex items-center gap-2",
              children: [_jsx("input", {
                type: "text",
                value: newReferralCode,
                onChange: e => setNewReferralCode(e.target.value),
                className: "referral-code-input rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm",
                placeholder: "Enter new code",
                ref: referallCodeRef
              }), _jsx(Button, {
                size: "sm",
                className: "referral-code-save-button",
                onClick: handleUpdateReferralCode,
                disabled: isUpdatingCode || !newReferralCode,
                children: isUpdatingCode ? _jsx(Loader2, {
                  className: "referral-code-save-loading h-4 w-4 animate-spin"
                }) : "Save"
              }), _jsx(Button, {
                size: "sm",
                variant: "ghost",
                className: "referral-code-cancel-button",
                onClick: () => {
                  setIsEditingCode(false);
                  setNewReferralCode("");
                },
                children: "Cancel"
              })]
            }) : _jsxs(_Fragment, {
              children: [_jsx("div", {
                className: "referral-code-display rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-sm",
                children: currentReferralCode
              }), _jsx(Button, {
                size: "icon",
                variant: "ghost",
                className: "referral-code-copy-button",
                onClick: handleCopyCode,
                children: _jsx(Copy, {
                  className: "referral-code-copy-icon h-4 w-4"
                })
              }), _jsx(Button, {
                size: "icon",
                variant: "ghost",
                className: "referral-code-edit-button",
                onClick: () => {
                  setIsEditingCode(true);
                  setTimeout(() => {
                    referallCodeRef.current?.focus();
                  }, 100);
                },
                children: _jsx(Pencil, {
                  className: "referral-code-edit-icon h-4 w-4"
                })
              })]
            })
          })]
        })]
      }), _jsxs("div", {
        className: "referred-users-container bg-b3-line rounded-xl p-4",
        children: [_jsx("div", {
          className: "referred-users-title text-b3-grey font-neue-montreal-semibold mb-4",
          children: "Referred Users"
        }), isLoadingReferrals ? _jsx("div", {
          className: "referred-users-loading flex justify-center py-4",
          children: _jsx(Loader2, {
            className: "h-6 w-6 animate-spin text-gray-400"
          })
        }) : referrals?.data?.length ? _jsx("div", {
          className: "referred-users-list space-y-3",
          children: referrals.data.map(referral => _jsxs("div", {
            className: "referred-user-item flex items-center justify-between rounded-lg bg-white p-3",
            children: [_jsx("div", {
              className: "referred-user-id text-sm font-medium",
              children: referral.referreeId
            }), _jsx("div", {
              className: "referred-user-date text-sm text-gray-500",
              children: new Date(referral.createdAt).toLocaleDateString()
            })]
          }, String(referral._id)))
        }) : _jsx("div", {
          className: "referred-users-empty py-4 text-center text-gray-500",
          children: "No referred users yet"
        })]
      })]
    }))]
  });
};